import gql from 'graphql-tag'


export const CreateHomeworkManager = gql`
mutation CreateHomeworkManager($name: String, $eventSummary: String, $category: String, $start: Date, $end: Date, $students: [Int],$teacherId: ID, $daily: Boolean) {
  createHomeworkManager(name: $name, eventSummary: $eventSummary, category: $category, start: $start, end: $end,  students: $students, teacherId: $teacherId, daily: $daily) {
    homeworkManager {
      id
      name
      eventSummary
      category
      students {
        id
        user {
          name
        }
      }
      start
      end
      daily
    }
  }
}
`


export const DeleteHomeworkManager = gql`
mutation DeleteHomeworkManager($id: ID!) {
  deleteHomeworkManager(id: $id) {
    id_
  }
}
`
